import React from 'react';
import { Typography } from '@mui/material';

export default function PolicyAndAddonName({ customer, addons }) {
  const addOnTitle = addons?.title || '';
  const policyName = customer?.contract?.policyName || '';

  if (addOnTitle) {
    return <Typography variant="p">{`${policyName} + ${addOnTitle}`}</Typography>;
  }

  return <Typography variant="p">{policyName}</Typography>;
}
